import Base, { type ControlStateInitObject } from './Base';
import type { AlexaV3DirectiveName, AlexaV3DirectiveValue, AlexaV3Request } from '../../types';

export default class DetectionState extends Base {
    constructor(opts: ControlStateInitObject) {
        super(opts);
    }

    static matches(event: AlexaV3Request): boolean {
        return (
            event?.directive?.header?.namespace === 'Alexa.MotionSensor' ||
            event?.directive?.header?.namespace === 'Alexa.ContactSensor'
        );
    }

    matches(event: AlexaV3Request): boolean {
        return DetectionState.matches(event);
    }

    static get DETECTED(): AlexaV3DirectiveName {
        return 'DETECTED';
    }

    static get NOT_DETECTED(): AlexaV3DirectiveName {
        return 'NOT_DETECTED';
    }

    alexaValue(value: ioBroker.StateValue | undefined): AlexaV3DirectiveValue {
        return value ? DetectionState.DETECTED : DetectionState.NOT_DETECTED;
    }

    value(alexaValue: AlexaV3DirectiveValue): ioBroker.StateValue | undefined {
        return alexaValue === DetectionState.DETECTED;
    }
}
